const buildFrontendUrl = (path) => {
    const frontendUrl = window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '') +
        path;
    return frontendUrl;
};
export default buildFrontendUrl;
